/**
 * FEEDBACK WIDGET — SCHEMA FORMULAIRE (TICKET-CRM-14)
 * Bornes spec : titre 5–150, description 10–5000 (requise).
 */

import { z } from 'zod';

export const feedbackFormSchema = z.object({
  type: z.enum(['bug', 'feature']),
  title: z
    .string()
    .trim()
    .min(5, 'Le titre doit contenir au moins 5 caractères')
    .max(150, 'Le titre ne peut pas dépasser 150 caractères'),
  description: z
    .string()
    .trim()
    .min(10, 'Décrivez le problème en au moins 10 caractères')
    .max(5000, 'La description ne peut pas dépasser 5000 caractères'),
});

export type FeedbackFormValues = z.infer<typeof feedbackFormSchema>;
